import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { UserSelectorInput } from 'modules/core/components/Inputs/UserSelector'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

interface Props {
  onEmployeeSelected: (employeeId: number[]) => void
  readonly?: boolean
}

const EmployeePreviewSelector = ({ onEmployeeSelected, readonly }: Props) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([])

  const handleEmployeeSelected = (ids: number[]) => {
    setSelectedIds(ids)
    onEmployeeSelected(ids)
  }

  return (
    <Box gap="s8">
      <UserSelectorInput
        users={users.models}
        onSubmit={handleEmployeeSelected}
        selectedIds={selectedIds}
        multiselect={false}
        allowsEmpty
        label={i18n.t('documents.document_templates.employee_preview.title')}
        placeHolder={i18n.t('documents.document_templates.employee_preview.placeholder')}
        submitEmptyLabel={i18n.t('documents.document_templates.employee_preview.select_none')}
        applySubmitLabelWithUsername
        readonly={readonly}
      />
      <Text size="200" color="grey800">
        {i18n.t('documents.document_templates.employee_preview.description')}
      </Text>
    </Box>
  )
}

export default observer(EmployeePreviewSelector)
